// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnTransparent_my_btn__fmNk-","arrow":"CustomBtnTransparent_arrow__uG6zm","arrow_rotated":"CustomBtnTransparent_arrow_rotated__pqqP-"};